import { render, staticRenderFns } from "./RegulariceStok.vue?vue&type=template&id=93ccda68&scoped=true"
import script from "./RegulariceStok.vue?vue&type=script&lang=js"
export * from "./RegulariceStok.vue?vue&type=script&lang=js"
import style0 from "./RegulariceStok.vue?vue&type=style&index=0&id=93ccda68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ccda68",
  null
  
)

export default component.exports